import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: {
      body: 'To learn more about legal notices, see ',
      link: 'our dedicated article',
    },
    label: 'Customised legal information',
  },
  fr: {
    description: {
      body: 'Pour en savoir plus sur les mentions légales, consultez ',
      link: 'notre article dédié',
    },
    label: 'Mentions légales personnalisées',
  },
} as const);

export default locales;
